import CoreAnchor, { type AnchorProps as CoreAnchorProps } from '@ovpn/ui/anchor';
import { forwardRef, type Ref } from 'react';
import { Link } from 'react-router-dom';

import type { AnyRecord } from '@sso/shared/types';
import { boxed } from '@sso/shared/hocs';

type AnchorProps = CoreAnchorProps & {
    state?: AnyRecord;
    replace?: boolean;
    to?: string;
};

function Anchor({ children, style, as, ...props }: AnchorProps, ref: Ref<HTMLAnchorElement>) {
    return (
        <CoreAnchor as={props.to ? Link : as} {...props} ref={ref}>
            {children}
        </CoreAnchor>
    );
}

export default boxed<AnchorProps, 'a'>(forwardRef(Anchor));
